<div class="agpr-network">
    <label
        id="networkMultiSelect_headerLabel"
        class="agpr-networkHeading"
    >
        {{ heading | localize }}
    </label>
    <ul
        class="agpr-networkRow"
        aria-labelledby="networkMultiSelect_headerLabel"
        [attr.aria-describedby]="ariaDescribedBy"
    >
        @for (network of networkOptions; track network.type) {
            <li>
                <agpr-checkbox
                    [id]="network.type"
                    class="agpr-networkRow-checkbox"
                    [ngClass]="{ 'agpr-network-partiallyModerated': network.isPartiallyModerated }"
                    [style]="checkboxTypesEnum.iconBadge"
                    [iconLabel]="network.icon"
                    [checkedIcon]="network.isPartiallyModerated ? 'fa-circle-exclamation fa-solid' : 'fa-circle-check'"
                    [iconBadgeTooltip]="network.tooltip"
                    [value]="network.type"
                    [(ngModel)]="value"
                    (ngModelChange)="onModelChange($event)"
                    (blur)="onBlur($event)"
                    [disabled]="allDisabledExceptTwitter && (network.type !== networkTypeEnum.twitter)"
                ></agpr-checkbox>
            </li>
        }
        @if (unavailableNetworkOptions?.length > 0) {
            @for (network of unavailableNetworkOptions; track network.type) {
                <li>
                    <agpr-checkbox
                        [id]="network.type"
                        class="agpr-networkRow-checkbox agpr-networkRow-checkbox--noPermissions"
                        [style]="checkboxTypesEnum.iconBadge"
                        [iconLabel]="network.icon"
                        [checkedIcon]="'fa-lock'"
                        [iconBadgeTooltip]="'Social.agentWidget.unavailableNetworks.tooltip' | localize : {network: network.tooltip}"
                        [value]="network.type"
                        [(ngModel)]="unavailableNetworkValue"
                        [disabled]="true"
                    ></agpr-checkbox>
                </li>
            }
        }
    </ul>

</div>
